import { WSButton, WSPage, WSText } from "@wingspanhq/fe-component-library";
import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useHistory } from "react-router-dom";
import { WSErrorMessage } from "../../components/WSErrorMessage/WSErrorMessage";
import { useWSMutation } from "../../query/helpers";
import { useUserId } from "../../query/hooks/helpers";
import { paymentsService } from "../../services/payments";

export const AdminReenablePayments: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const [enable, enableMeta] = useWSMutation(
    async () => {
      await paymentsService.service.update(userId, {
        verifications: {
          taxDocumentation: VerificationStatus.Verified,
          banking: VerificationStatus.Verified,
          cardPayments: VerificationStatus.Verified
        }
      });
    },
    {
      onSuccess: () => {
        history.push("/member/invoices");
      }
    }
  );
  return (
    <WSPage title="Request a member">
      <WSText mb="XL">Reenable payment service</WSText>

      <WSButton mb="XL" onClick={enable} loading={enableMeta.isLoading}>
        Reenable
      </WSButton>

      <WSErrorMessage error={enableMeta.error} contextKey="PaymentsSetup" />
    </WSPage>
  );
};
